import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import SectionSwiper from "./component/sectionSwiper";
import SessionManager from "./component/sessionManager";

import { MainContainer } from "./component/styled/main";
import { mainSection } from "./component/function/common";

// 메인페이지
const Main = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.data[0]);

  useEffect(() => {
    handleCreateSession();
  }, []);

  // 새로운 세션 생성
  const handleCreateSession = async () => {
    const sessionData = JSON.parse(sessionStorage.getItem("monotiSessionData"));
    const sessionId = sessionData?.id;

    if (sessionId) {
      await handleSessionEnd(sessionId);
    }

    try {
      const data = {
        os: "web",
        screenId: "W0",
      };

      const response = await axios.post("/erp/session/createSession", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const res = response.data;
      console.log(res);

      if (res?.createdAt) {
        // console.log(`세션 생성 성공: ${res.id}`);
        sessionStorage.setItem("monotiSessionData", JSON.stringify({ ...res }));
      } else {
        // console.log(`세션 생성 실패: ${res}`);
      }
    } catch (error) {
      console.error("세션 생성 오류:", error);
    }
  };

  // 세션 종료
  const handleSessionEnd = async (sessionId) => {
    const url = "/erp/session/endSession";
    try {
      const response = await axios.post(url, { sessionId });

      const { success } = response.data;
      if (success) {
        sessionStorage.removeItem("monotiSessionData");
      }
    } catch (error) {
      console.error("세션 종료 요청 실패:", error);
    }
  };

  const openMyPage = async () => {
    if (user) {
      navigate("/mypage/shop");
    } else {
      navigate("/login");
    }
  };

  const handleNavigate = (item) => {
    if (item.key === "shop") {
      openMyPage();
    } else {
      navigate(`${item.path}`);
    }
  };

  return (
    <MainContainer>
      <SessionManager />
      <SectionSwiper />
      {mainSection.map((item) => (
        <div className={`mainSection ${item.key}`}>
          <div className="inner">
            <div className="img">
              <img src={`/img/main_section_${item.key}.png`} />
            </div>
            <div className="content">
              <span className="title">{item.title}</span>
              <strong>{item.info}</strong>
              <span className="details">{item.details}</span>
              <button onClick={() => handleNavigate(item)}>바로가기</button>
            </div>
          </div>
        </div>
      ))}
      {/* <Video />
      <Feature />
      <Member /> */}
    </MainContainer>
  );
};

export default Main;
